import { render, staticRenderFns } from "./change-datafile-status-modal.vue?vue&type=template&id=0b58178c"
import script from "./change-datafile-status-modal.vue?vue&type=script&lang=js"
export * from "./change-datafile-status-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports